import React from 'react';
import { Typography, Space, Layout, Divider } from 'antd';

const { Title, Paragraph, Text } = Typography;
const { Content } = Layout;

const PrivacyPolicyPage: React.FC = () => {
  return (
    <Layout style={{ minHeight: '100vh', padding: '24px' }}>
      <Content style={{ background: '#fff', padding: '24px', borderRadius: '8px', maxWidth: '800px', margin: '0 auto' }}>
        <Typography>
          <Title level={1} style={{ textAlign: 'center' }}>Privacy Policy</Title>
          <Text type="secondary" style={{ display: 'block', textAlign: 'center', marginBottom: '24px' }}>
            Effective Date: April 4, 2025
          </Text>

          <Divider />

          <Title level={2}>1. Introduction</Title>
          <Paragraph>
            This Privacy Policy outlines how Flow Learning ("we", "our", or "us") collects, uses, and protects the personal information of its users. 
            We are committed to ensuring the privacy and security of your data.
          </Paragraph>

          <Title level={2}>2. Information Collection</Title>
          <Paragraph>
            We collect the following personal information:
          </Paragraph>
          <Space direction="vertical" style={{ width: '100%', marginBottom: '16px' }}>
            <Paragraph>
              <Text strong>Account Information:</Text> Name, email address, and profile picture (if provided).
            </Paragraph>
            <Paragraph>
              <Text strong>Authentication Data:</Text> Information received from third-party authentication providers when you use Single Sign-On (SSO) 
              services such as Google, Microsoft, Facebook, Discord, or Twitter.
            </Paragraph>
            <Paragraph>
              <Text strong>Usage Data:</Text> Information about how you interact with our platform, including nodes and connections you create or interact with.
            </Paragraph>
          </Space>
          <Paragraph>
            This information is collected when you register for an account, log in using SSO, or use our services.
          </Paragraph>

          <Title level={2}>3. Information Use</Title>
          <Paragraph>
            We use the collected information to:
          </Paragraph>
          <ul>
            <li>Provide and maintain our learning flow platform.</li>
            <li>Authenticate users and manage user accounts.</li>
            <li>Improve and personalize user experience.</li>
            <li>Analyze usage patterns to enhance our services.</li>
            <li>Communicate with users about their accounts and our services.</li>
          </ul>

          <Title level={2}>4. Data Sharing</Title>
          <Paragraph>
            We do not sell your personal information to third parties. We may share your information in the following circumstances:
          </Paragraph>
          <ul>
            <li>With third-party service providers who help us operate our platform.</li>
            <li>When required by law or to protect our rights.</li>
            <li>With your consent or at your direction.</li>
          </ul>

          <Title level={2}>5. Data Security</Title>
          <Paragraph>
            We implement reasonable security measures to protect user data from unauthorized access, disclosure, alteration, or destruction. 
            These measures include:
          </Paragraph>
          <ul>
            <li>Encryption of sensitive data.</li>
            <li>Secure authentication protocols.</li>
            <li>Regular security assessments.</li>
            <li>Limited access to personal information.</li>
          </ul>

          <Title level={2}>6. User Rights</Title>
          <Paragraph>
            You have the right to:
          </Paragraph>
          <ul>
            <li>Access the personal information we hold about you.</li>
            <li>Request correction of inaccurate information.</li>
            <li>Request deletion of your account and associated data.</li>
            <li>Opt out of certain data collection practices.</li>
          </ul>
          <Paragraph>
            To exercise these rights, please contact us using the information provided in Section 9.
          </Paragraph>

          <Title level={2}>7. Cookies and Similar Technologies</Title>
          <Paragraph>
            We use cookies and similar technologies to enhance your experience on our platform. These technologies help us 
            authenticate users, remember preferences, and analyze usage patterns.
          </Paragraph>

          <Title level={2}>8. Changes to This Policy</Title>
          <Paragraph>
            We may update this Privacy Policy from time to time. We will notify users of any significant changes by posting 
            a revised version on our website with a new effective date.
          </Paragraph>

          <Title level={2}>9. Contact Information</Title>
          <Paragraph>
            If you have any questions about this Privacy Policy or our practices, please contact us at:
          </Paragraph>
          <Paragraph>
            Email: <a href="mailto:flow-learning@example.com">flow-learning@example.com</a>
          </Paragraph>
          <Paragraph>
            By using our website, you consent to the terms of this Privacy Policy.
          </Paragraph>

          <Divider />
          <Paragraph style={{ textAlign: 'center' }}>
            &copy; 2025 Flow Learning. All rights reserved.
          </Paragraph>
        </Typography>
      </Content>
    </Layout>
  );
};

export default PrivacyPolicyPage;